export const FALLBACK_TIME_ZONE = "UTC";
const verdicts = new Map();
export function isValidTimeZone(tz) {
    if (!tz)
        return false;
    const cached = verdicts.get(tz);
    if (cached !== undefined)
        return cached;
    let ok = false;
    try {
        new Intl.DateTimeFormat("en-GB", { timeZone: tz }).format(new Date(0));
        ok = true;
    }
    catch {
        ok = false;
    }
    verdicts.set(tz, ok);
    return ok;
}
export function safeTimeZone(tz) {
    if (!tz)
        return { timeZone: FALLBACK_TIME_ZONE };
    if (isValidTimeZone(tz))
        return { timeZone: tz };
    return { timeZone: FALLBACK_TIME_ZONE, invalid: tz };
}
export function coerceTimeZone(tz) {
    return safeTimeZone(tz).timeZone;
}
